import { gql } from '@apollo/client';

export const LoginMutation = gql`
    mutation LoginMutation {
        loginResponse(input: $requestBody)
            @rest(
                type: loginResponse
                method: POST
                path: "/credentials/login/v2"
            ) {
            kratosSessionId
            kratosSessionToken
            validDeviceToken
            validChallenge
        }
    }
`;

export type LoginResponse = {
    kratosSessionId: string;
    kratosSessionToken?: string;
    validDeviceToken?: boolean;
    validChallenge?: boolean;
};
